<template>
    <div style="box-shadow: rgba(0, 0, 0, 0.03) 0px 8px 15px; margin: 0 -16px; margin-bottom: 0px; overflow: hidden;">
        <v-subheader :key="i" style="font-size: 15px; text-transform: none; padding: 0px 16px; margin: 0;"
                     @click="toggleOpened"
            :class="active ? 'black--text text--darken-3' : 'grey--text'">
            <span style="flex-grow: 1">{{ $t("plan_simple.template_"+protocol.title) }}</span>

            <!-- <span v-if="!active" style="padding: 2px 10px; font-size: 12px; text-transform: none;">{{ $t('settings.inactive') }}</span> -->
            <!--v-btn fab small outline flat style="margin: 0 0 0 16px; padding: 0; width: 24px; height: 24px;" @click="$bus.$emit('pricelist:previewAnimation', name)">
                <v-icon style="color:#888; font-size: 30px;">play_circle_outline</v-icon>
            </v-btn-->

            <!-- <span><v-icon style="margin: 0; border-radius: 16px; padding: 0; font-size: 30px;" v-text="opened ? 'arrow_drop_up' : 'arrow_drop_down'"></v-icon></span> -->
            <span>
                <span style="color: #1565c0; font-weight: 600; border: 2px solid #1565c0!important; border-radius: 16px; padding: 2px 10px; font-size: 11px; text-transform: none; display: inline-block; margin-top: 0px;" @click="$bus.$emit('pricelist:previewAnimation', name)">
                PLAY
            </span>
            </span>
        </v-subheader>

        <div v-if="opened" style="background: #fff; padding: 8px 16px;">

            <div style="margin-top: 8px; font-size: 12px; line-height: 1.4; color: #aaa;" v-if="$te('protocol_descriptions.'+protocol.title) && $t('protocol_descriptions.'+protocol.title) !== ''" v-html="$t('protocol_descriptions.'+protocol.title)"></div>

            <!-- <div v-if="['full_dentures', 'full_bridge', 'preci_vertix'].includes(protocol.title)">
                <div style="margin-top: 12px; color: #777;" v-html="$t('settings.package_prices') + ':'" />
            </div>
            <div v-else style="margin-top: 12px; color: #777;" v-html="$t('settings.package_prices') + ' ' + $t('settings.by_implants') + ':'" /> -->

            <!-- <pm-pricelist-preview :protocolName="name" /> -->

            <pm-price-list-protocol
                v-for="i in optionCount"
                :key="i"
                :protocol="protocol"
                :index="i - 1"
                @toggle="toggle(i)"
                @focused="$emit('focused')"
                @blurred="$emit('blurred')"
            />

            <div style="text-align: center; margin-top: 20px;">
                <v-btn v-if="active && ['full_jaw_6_12','full_jaw_6_14','full_jaw_8_12','full_jaw_8_14'].includes(protocol.title)" small outline flat style="border-radius: 16px; border: 2px solid #888!important; margin: 0; padding: 0 10px;" @click="createOption">
                    <v-icon style="color:#555;">add</v-icon> {{ $t('settings.add_option') }}
                </v-btn>
            </div>
            <br>

        </div>
    </div>
</template>

<script>
import PmPriceListProtocol from "./pricelist_protocol";
import PmPricelistPreview from "./pricelist-preview";

export default {
    props: ["name"],
    components: {
        PmPriceListProtocol,
        PmPricelistPreview
    },
    computed: {
        protocol() {
            return this.$store.state.localSettings.protocols[this.name];
        },
    },
    data() {
        return({
            opened: 1,
            optionCount: 3,
            active: this.$store.state.localSettings.protocols[this.name].active,
        });
    },
    created() {
        try {
            let maxCnt = 3;
            const cnt = this.$store.state.localSettings.protocols[this.name].variation_titles.length;
            if (cnt > maxCnt) maxCnt = cnt;
            this.optionCount = maxCnt;
            this.opened = typeof this.$store.state.localSettings.protocols[this.name].opened !== "undefined" ? this.$store.state.localSettings.protocols[this.name].opened : 1;
        } catch(error) {
            captureException(error);
        }
    },
    methods: {
        toggleOpened() {
            let opened = this.opened;
            //this.$set(this.$store.state.localSettings.protocols[this.name], "opened", 1-opened);
            this.$set(this.$store.state.localSettings.protocols[this.name], "opened", 1);
            //this.opened = 1 - this.opened;
            this.opened = 1;
            this.$emit('save');
        },
        enableProtocol() {
           this.$set(this.protocol.variation_active, 0, "1");
           this.toggle(1);
           this.active = true;
        },
        createOption() {
            this.optionCount++;
            this.protocol.variation_titles.push({});
            this.protocol.variation_prices.push({});
            this.protocol.variation_active.push("1");
            this.$emit('save');
        },
        toggle(i) {
            i = parseInt(i) - 1;
            if (i>=3) {
                if (parseInt(this.protocol.variation_active[i]) === 0) {
                    let titles = Object.values(this.protocol.variation_titles[i]).filter((v) => {
                        return (v !== '' && v!== null);
                    });
                    let prices = Object.values(this.protocol.variation_prices[i]).filter((v) => {
                        return (v !== '' && v!== 0 && v!== null && v!== "0");
                    });
                    if (titles.length === 0 && prices.length === 0) {
                        this.$store.state.localSettings.protocols[this.name].variation_titles.splice(i, 1);
                        this.$store.state.localSettings.protocols[this.name].variation_prices.splice(i, 1);
                        this.$store.state.localSettings.protocols[this.name].variation_active.splice(i, 1);
                        /**this.protocol.variation_titles.splice(i, 1);
                        this.protocol.variation_prices.splice(i, 1);
                        this.protocol.variation_active.splice(i, 1);*/
                        this.optionCount--;
                    }
                }
            }


            let cnt = 0;

            this.protocol.variation_active.forEach((variation) => {
                if (variation === "1") {
                    cnt++;
                }
            });

            this.$store.state.localSettings.protocols[this.name].active = cnt > 0 ? 1 : 0;
            this.active = this.$store.state.localSettings.protocols[this.name].active;

            this.$nextTick(()=>{
                this.$emit('save');
            });
        },
    },
};
</script>
